import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiNotificationPopover, SuiNotification } from '@splashthat/sui';

const DEFAULT_APP_CRASH_ERROR_MSG = 'Oops! Our app crashed. Give us a second, our team is on it.';

/**
 * It should wrap the full react application so that users see an error message when
 * the app crashes due to a error thrown inside the React.Component render() callstack.
 */
export default class TopLevelAppErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    state = {
        hasError: false,
    };

    componentDidCatch() {
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return (
                <SuiNotificationPopover>
                    <SuiNotification variation="ERROR" message={DEFAULT_APP_CRASH_ERROR_MSG} onClose={() => {}} />
                </SuiNotificationPopover>
            );
        }
        return this.props.children;
    }
}
